<p-accordion #accordion>
    <p-accordionTab *ngFor="let item of items" [selected]="item.open">
        <ng-template pTemplate="header">
            <ng-container *ngTemplateOutlet="item.headImpl">Bum</ng-container>
        </ng-template>
        <ng-template pTemplate="content">
            <ng-container *ngTemplateOutlet="item.contentImpl"></ng-container>
        </ng-template>
    </p-accordionTab>
</p-accordion>
